// @ts-ignore
import pairwise from 'pairwise';
import { ITrackerEvent } from '../../trackers/interfaces-api';

export const getMarkerOpacity = (index: number, events: ITrackerEvent[]) => {
    const max = events.length;
    return (index + 1) / max;
};

export const getVectors = (events: ITrackerEvent[]) => {
    const positions = events.map((e) => [e.latitude, e.longitude]);

    return pairwise(positions);
};

export const MINIMAL_VECTOR_OPACITY = 0.5;

export const getVectorOpacity = (index: number, vectors: any) => {
    const max = vectors.length;
    // we set the opacity to a minimum so that we can still see
    // very distant points at the beginning of the path.
    // Indeed, with many points, a position that is far away at
    // the beginning will be invisible on the map.
    if ((index + 1) / max < MINIMAL_VECTOR_OPACITY) {
        return MINIMAL_VECTOR_OPACITY;
    }

    return (index + 1) / max;
};
